
import ClearIcon from '@mui/icons-material/Clear';
import InsightsIcon from '@mui/icons-material/Insights';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Stack, Typography } from '@mui/material';
import { forwardRef, useState } from 'react';
import { useNavigate } from 'react-router';
import CustomButton from '../../Components/UiComponents/CustomButton';
import SecondaryButton from '../../Components/UiComponents/SecondaryButton';
import { COMPLETIONS_MODEL_PROVIDERS } from '../../Configs/JobConstants';
import { PAGE_ROUTES } from '../../Configs/Routes';
import { color } from '../../Styles/Color';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const NewFineTuningModal = ({ isOpen, handleClose }) => {

  const navigate = useNavigate()

  const [isActive, setIsActive] = useState(COMPLETIONS_MODEL_PROVIDERS[0].name)

  const handleLaunch = () => {
    navigate(PAGE_ROUTES.newFineTuning, { state: { model: isActive } })
  }

  return (
    <Dialog
      maxWidth="xl"
      open={isOpen}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          px: 2,
          py: 1,
          boxShadow: "0px 0px 4px 0px #00000014"
        }
      }}
      TransitionComponent={Transition}
      keepMounted
      slotProps={{
        backdrop: {
          sx: {
            background: "#E4E4E48A",
            backdropFilter: "blur(3px)",
          },
        }
      }}
    >
      <DialogTitle sx={{ p: 2 }}>
        <Stack justifyContent="space-between" direction="row">
          <Stack direction="row" gap={2} alignItems="center">
            <Stack
              padding={1}
              borderRadius="8px"
              bgcolor={color.primary}
              color={color.white}
            >
              <InsightsIcon fontSize='20px' />
            </Stack>
            <Typography variant='h2' color={color.primary}>Launch New Fine-tuning Job</Typography>
          </Stack>
          <IconButton onClick={handleClose}>
            <ClearIcon sx={{ fontSize: '24px', color: color.primary }} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent
        sx={{
          minHeight: "15vh",
          width: "40vw",
          p: 2,
          '&::-webkit-scrollbar': {
            display: 'none',
          }
        }}
      >
        <Stack spacing={3}>
          <Typography variant='h3'>Choose a Model to Fine-tune</Typography>
          <Stack direction="row" gap={3} flexWrap='wrap' width="38vw" pb={3}>
            {
              COMPLETIONS_MODEL_PROVIDERS
                // .filter(m => m.name !== "Qwen")
                .map(({ name, icon }) => (
                  <Stack key={name} spacing={2} alignItems="center" onClick={() => setIsActive(name)}>
                    <Stack
                      width="80px"
                      height="80px"
                      justifyContent="center"
                      alignItems="center"
                      border="1px solid"
                      borderColor={isActive === name ? color.primary : color.borders}
                      borderRadius="6px"
                      bgcolor={isActive === name && color.lightBlue}
                      sx={{
                        cursor: "pointer",
                      }}
                    >
                      {icon}
                    </Stack>
                    <Typography
                      variant='h3'
                      color={isActive === name && color.primary}
                    >
                      {name}
                    </Typography>
                  </Stack>
                ))
            }
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
          <Stack
            direction="row"
            gap={1}
            color={color.primary}
            alignItems="center"
            sx={{
              "&:hover": {
                cursor: "pointer"
              }
            }}
            onClick={() => window.open("https://docs.scalegen.ai/ft-guide", "_blank")}
          >
            <MenuBookIcon fontSize='small' />
            <Typography variant='body1'>
              Docs
            </Typography>
          </Stack>

          <Stack direction="row" gap={1}>
            <SecondaryButton onClick={handleClose}>
              Cancel
            </SecondaryButton>
            <CustomButton
              onClick={handleLaunch}
              width="10%"
            >
              Launch
            </CustomButton>
          </Stack>
        </Stack>
      </DialogActions>
    </Dialog >
  )
}

